import React from "react";
import iconCheck from "../assets/images/icon-check.svg";
import iconCredit from "../assets/images/icon-credit-card.svg";
import iconTruck from "../assets/images/icon-truck.svg";
import iconRepas from "../assets/images/repas.svg";
import wecookVert from "../assets/images/wecook-vert-512.svg";
import "./Nav.css";

const steps = [
  { icon: iconTruck, label: "Livraison" },
  { icon: iconRepas, label: "Repas" },
  { icon: iconCredit, label: "Finaliser" },
];

export default function Nav({ activeStep = 0, onStepClick }) {
  return (
    <nav className="nav">
      <div className="nav-logo">
        <img src={wecookVert} alt="WeCook" />
      </div>

      <div className="nav-steps">
        {steps.map((step, i) => {
          const isActive = i === activeStep;
          const isCompleted = i < activeStep;
          return (
            <button
              key={i}
              className={[
                "nav-step",
                isActive ? "nav-step--active" : "",
                isCompleted ? "nav-step--completed" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => onStepClick && onStepClick(i)}
              aria-current={isActive ? "step" : undefined}
            >
              <img
                src={isCompleted ? iconCheck : step.icon}
                alt=""
                className="nav-step-icon"
              />
              <span>{step.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
